import { InboxPivotDisplayProperties } from '../store/schema/InboxPivotDisplayProperties';
import InboxClassificationFilter from '../store/schema/InboxClassificationFilter';
import { MailIcons } from 'owa-mail-icons';
import { ControlIcons } from 'owa-addins-icons';
import { allTab, promotionsTab, socialTab, newslettersTab } from '../strings.locstring.json';
import { otherViewFilterText } from 'owa-locstrings/lib/strings/otherviewfiltertext.locstring.json';
import { focusedViewFilterText } from 'owa-locstrings/lib/strings/focusedviewfiltertext.locstring.json';
import loc from 'owa-localize';
import inboxPlusStore from '../store/Store';
import folderStore from 'owa-folders';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

export default function getInboxPlusPivotDisplayProperties(
    pivotType: InboxClassificationFilter
): InboxPivotDisplayProperties {
    switch (pivotType) {
        case InboxClassificationFilter.None:
            const enabledPivots = inboxPlusStore.inboxPlusPivots.filter(pivot => pivot.isEnabled);
            return {
                displayText:
                    // Display text is 'Inbox' when it's the only enabled pivot, otherwise it's displayed as 'All'
                    enabledPivots.length === 1
                        ? folderStore.folderTable.get(folderNameToId('inbox')).DisplayName
                        : loc(allTab),
                icon: ControlIcons.Inbox,
            };
        case InboxClassificationFilter.Focused:
            return {
                displayText: loc(focusedViewFilterText),
                icon: MailIcons.InboxCheck,
            };
        case InboxClassificationFilter.Promotions:
            return {
                displayText: loc(promotionsTab),
                icon: MailIcons.ShoppingCart,
            };
        case InboxClassificationFilter.Social:
            return {
                displayText: loc(socialTab),
                icon: ControlIcons.Like,
            };
        case InboxClassificationFilter.Newsletters:
            return {
                displayText: loc(newslettersTab),
                icon: MailIcons.News,
            };
        case InboxClassificationFilter.Other:
            return {
                displayText: loc(otherViewFilterText),
                icon: MailIcons.MailLowImportance,
            };
        default:
            return null;
    }
}
